import BaseCurrencyConverter from '@/shared/js/services/BaseCurrencyConverter'
import { currencySymbol } from '@/utils/currencySymbol'

export default new BaseCurrencyConverter([], currencySymbol)
